import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
const LoginNav = () => {
  return (
    <>
      <Nav className="ml-auto" navbar>
        <NavItem className="register-nav">
          <NavLink>Not a registered user?</NavLink>
        </NavItem>
        <NavItem className="register-nav center-btn">
          <a
            href="/register/payments-platform"
            className="btn-support btn-signup"
          >
            Sign Up
          </a>
        </NavItem>
      </Nav>
    </>
  );
};

export default LoginNav;
